import { useMemo } from "react";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";
import { Keyboard, Moon, Plus, Search, SunMedium } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

interface GlobalCommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateNote: () => void;
  onOpenShortcuts: () => void;
  onNavigate?: (path: string) => void;
}

export function GlobalCommandPalette({
  open,
  onOpenChange,
  onCreateNote,
  onOpenShortcuts,
  onNavigate,
}: GlobalCommandPaletteProps) {
  const { theme, toggleTheme } = useTheme();

  const navigationItems = useMemo(
    () => [
      { label: "Dashboard", path: "/dashboard" },
      { label: "Profile settings", path: "/profile" },
      { label: "Join meeting", path: "/join" },
    ],
    [],
  );

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search actions or destinations..." />
      <CommandList>
        <CommandEmpty>No matches found.</CommandEmpty>
        <CommandGroup heading="Quick actions">
          <CommandItem
            onSelect={() => {
              onCreateNote();
              onOpenChange(false);
            }}
          >
            <Plus className="mr-2 h-4 w-4" />
            Create new note
          </CommandItem>
          <CommandItem
            onSelect={() => {
              toggleTheme();
              onOpenChange(false);
            }}
          >
            {theme === "dark" ? (
              <SunMedium className="mr-2 h-4 w-4" />
            ) : (
              <Moon className="mr-2 h-4 w-4" />
            )}
            Toggle theme
          </CommandItem>
          <CommandItem
            onSelect={() => {
              onOpenShortcuts();
              onOpenChange(false);
            }}
          >
            <Keyboard className="mr-2 h-4 w-4" />
            View shortcuts
          </CommandItem>
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Navigation">
          {navigationItems.map((item) => (
            <CommandItem
              key={item.path}
              onSelect={() => {
                onNavigate?.(item.path);
                onOpenChange(false);
              }}
            >
              <Search className="mr-2 h-4 w-4" />
              {item.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}

export default GlobalCommandPalette;
